import { MobxZodField } from '@monoid-dev/mobx-zod-form';
import { ZodTypeAny } from 'zod';

export const shouldDisplayErrorMessages = (field: MobxZodField<ZodTypeAny>) => {
  return (field.errorMessages.length > 0 || field.extraErrorMessages.length > 0) && field.touched;
};

export interface InputCommonProps {
  /**
   * Append an ErrorMessages under the container
   */
  withErrorMessages?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
}
